import { lazyShowUserVoiceSuggestionDialog, SuggestionDialogOptions } from 'owa-uservoice';
import {
    TypeValues,
    UserVoiceFeedbackTxpTags,
} from 'owa-uservoice/lib/services/UserVoiceFeedbackTags';
import InferredEntityIds from '../store/schema/InferredEntityIds';
import isInferencesDSATSupported from '../utils/featureChecks/isInferencesDSATSupported';
import postUserVoiceSuggestionAction from './postUserVoiceSuggestionAction';
import ReportIssue from '../components/ReportIssue';
import { getOwaTxpStrings } from 'owa-strings/owa-txp-strings';
import UserVoiceFeedbackType from 'owa-service/lib/contract/UserVoiceFeedbackType';
import UserVoiceSuggestion from 'owa-service/lib/contract/UserVoiceSuggestion';

const TITLE = 'New Ticket from Outlook.com';
export const UserVoiceForumUrl: string = 'https://outlook.uservoice.com/forums/912016/';

export function sendFeedback(): void {
    window.open(UserVoiceForumUrl, '_blank');
}

export async function reportIssue(
    userVoiceData: UserVoiceFeedbackTxpTags,
    itemId: string,
    inferredEntityIds?: InferredEntityIds
) {
    userVoiceData.Type = TypeValues.Support;
    const postUVSuggestionAction = isInferencesDSATSupported()
        ? (suggestion: UserVoiceSuggestion) =>
              postUserVoiceSuggestionAction(suggestion, inferredEntityIds)
        : null;

    (await lazyShowUserVoiceSuggestionDialog.import())({
        title: TITLE,
        feedbackType: UserVoiceFeedbackType.TailoredExperiences,
        ewsId: itemId,
        header: getOwaTxpStrings().negativeTicketPopUpHeaderText,
        blurbElement: ReportIssue(),
        customTags: userVoiceData,
        postUserVoiceSuggestionAction: postUVSuggestionAction,
    } as SuggestionDialogOptions);
}

export async function sendNegativeFeedback(userVoiceData: UserVoiceFeedbackTxpTags) {
    userVoiceData.Type = TypeValues.Negative;
    (await lazyShowUserVoiceSuggestionDialog.import())({
        title: TITLE,
        feedbackType: UserVoiceFeedbackType.TailoredExperiences,
        header: getOwaTxpStrings().positiveTicketPopUpHeaderText,
        blurb: getOwaTxpStrings().positiveTicketPopUpBodyText,
        customTags: userVoiceData,
    } as SuggestionDialogOptions);
}
